import React from "react";

const Header: React.FC = () => <header id="header">和大の空き教室検索システム</header>;

export default Header;
